import axios from 'axios'
import getHeaders from '../../helpers/headers'
import config from '../../../constants/endpoints.js'

const {
  endpoints: {
    plugins: {
      payment: { create_new_link, cancel_link, custom_link },
    },
  },
} = config

/**
 * Creates a new payment link.
 *
 * @param {String} params.user Id of the user in the database
 * @param {String} params.lang Language string of the user
 */
const createNewLink = (params) => axios.get(create_new_link, { headers: getHeaders(true), params })

/**
 * Cancels the last payment link of an user.
 *
 * @param {Object} data.userId User
 * @param {String} data.orderId The user state after cancelling the payment link
 */
const cancelLink = (data) =>  axios.post(cancel_link, data, { headers: getHeaders(true) })

/**
 * Create a custom payment link.
 *
 * @param {Object} data.user User data
 * @param {Object} data.data Data needed to create the link
 * @param {String} data.data.concept Concept of the payment
 * @param {Number} data.data.price Price of the payment
 */
const getCustomPaymentLink = (data) => axios.post(custom_link, data, { headers: getHeaders(true) })

export default {
  createNewLink,
  cancelLink,
  getCustomPaymentLink,
}
